import upload from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-documents/actions/upload.js';

export default () => ({
    state: {
        fileTypes: [
            '3gp',
            'csv',
            'doc',
            'docx',
            'gif',
            'jpeg',
            'jpg',
            'json',
            'mov',
            'wmv',
            'mp3',
            'mp4',
            'pdf',
            'png',
            'ppt',
            'txt',
            'xls',
            'xlsx',
            'xml',
        ],
    },
    actions: { upload },
});